import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import AdminShell from "./components/admin-shell/AdminShell";
import Home from "./screens/home/Home";
import AllDonor from "./screens/donorList/AllDonor";
import Gallary from "./screens/gallary/Gallary";
import Others from "./screens/others/Others";
import AppRegistration from "./screens/public/AppRegistration";
import Login from "./screens/login/Login";
import Welcome from "./screens/public/Welcome";
import PublicPost from "./screens/public/PublicPost";
import BloodSearch from "./screens/blood/BloodSearch";
import MyProfile from "./screens/user/MyProfile";
import Feed from "./screens/user/Feed";
import Members from "./screens/user/Members";
import Messages from "./screens/user/Messages";
import MessageThread from "./screens/user/MessageThread";

const AppRoutes = ({ user, setUser, endUser }) => {
    return (
        <div className="a">
            <Routes>
                {/* Public */}
                <Route
                    path="/"
                    element={
                        endUser ? <Navigate to="/feed" replace /> : <Welcome />
                    }
                />
                <Route
                    path="/admin-login"
                    element={user ? <Navigate to="/home" replace /> : <Login setUser={setUser} />}
                />
                <Route path="/login" element={<Navigate to="/admin-login" replace />} />
                <Route path="/app-registration" element={<AppRegistration />} />
                <Route path="/post/:postId" element={<PublicPost endUser={endUser} />} />
                <Route path="/blood" element={<BloodSearch />} />

                {/* End User */}
                <Route
                    path="/feed"
                    element={endUser ? <Feed endUser={endUser} /> : <Navigate to="/" replace />}
                />
                <Route
                    path="/my-profile"
                    element={endUser ? <MyProfile /> : <Navigate to="/" replace />}
                />
                <Route
                    path="/members"
                    element={endUser ? <Members endUser={endUser} /> : <Navigate to="/" replace />}
                />
                <Route
                    path="/messages"
                    element={endUser ? <Messages endUser={endUser} /> : <Navigate to="/" replace />}
                />
                <Route
                    path="/messages/:conversationId"
                    element={endUser ? <MessageThread endUser={endUser} /> : <Navigate to="/" replace />}
                />

                {/* Admin */}
                <Route
                    element={
                        user ? <AdminShell admin={user} setUser={setUser} /> : <Navigate to="/admin-login" replace />
                    }
                >
                    <Route path="/home" element={<Home />} />
                    <Route path="/allDonor" element={<AllDonor />} />
                    <Route path="/gallary" element={<Gallary />} />
                    <Route path="/others" element={<Others />} />
                </Route>
            </Routes>
        </div>
    );
};

export default AppRoutes;
